import React from "react";
import DataTable from "./DataTable";
import { Card, Grid, Typography, makeStyles } from "@material-ui/core";
import StackAreaChartContainer from "./StackAreaChartContainer";
import { getUniqueValues } from "../../util/customFunctions";
import ExportPPtx from "../../components/ExportPPT";

const styles = makeStyles((theme) => ({
  grid: {
    width: "95%",
    margin: "auto",
    marginTop: "1rem",
  },
}));

const BuildingPipelineCardv2 = (props) => {
  const chartRef = React.createRef();

  const classes = styles();
  return (
    <Grid key={"ixixwer"} className={classes.grid} item xs={12}>
      <Grid container  >
        <Grid item style={{ padding: "1rem", position: "relative" }} xs={12}>
          <Typography align="center" variant="h2" style={{ margin: "0.5rem" }}>
            {props.title}
          </Typography>

          {/* <div style={{ position: "absolute", top: "1rem", right: "1rem" }}>
            <ExportPPtx chartRef={chartRef} title={props.title} />
          </div> */}
        </Grid>

        <Grid
          item
          xs={12}
          // style={{ paddingRight: "5rem" }}
          // justify="flex-start"
          justifyContent="center"
          container
        >
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            xs={12}
            md={
              props.data.uniqueTimeFrames
                .filter(getUniqueValues)
                .filter((f) => f !== "Total").length <= 4
                ? 9
                : 12
            }
            ref={chartRef}
          >
            <StackAreaChartContainer
              cumulativeData={props.data.commulativeACVData}
              cumulativeGoalData={props.data.comulativeGoalData}
              type={props.data.type}
              quarter={props.data.timeFrame}
              uniqueQuarters={props.data.uniqueTimeFrames}
              acvCol="totalActual"
              id={`stackAreaChartv2${props.ind}`}
            />
          </Grid>

        </Grid>
      </Grid>
    </Grid>
  );
};

export default BuildingPipelineCardv2;
